export const GET_MEMBER_INSTRUMENTS = "GET_MEMBER_INSTRUMENTS";
export const GET_MEMBER_INSTRUMENT_BY_ID = "GET_MEMBER_INSTRUMENT_BY_ID";
export const UPDATE_MEMBER_INSTRUMENT = "UPDATE_MEMBER_INSTRUMENT";
export const DELETE_MEMBER_INSTRUMENT = "DELETE_MEMBER_INSTRUMENT";
export const CREATE_MEMBER_INSTRUMENT = "CREATE_MEMBER_INSTRUMENT";
